import(/* webpackMode: "eager" */ "/home/runner/work/MissionControl-v4/MissionControl-v4/src/app/global-error.tsx");
